export default "__VITE_ASSET__4WMLUSp1__"